import styled from 'styled-components';
import tw from 'twin.macro';

export const SubHeaderContainer = styled.div(() => [
  tw`bg-silver-lighten-30 border-b border-solid border-silver-lighten-15`
]);

export const SubHeaderMainContent = styled.ul(() => [
  tw`pt-8 mb-8 md:flex md:flex-wrap md:justify-center`
]);

export const SubHeaderBodyContent = styled.ul(() => [
  tw`flex mt-8 pb-8 md:justify-center`
]);
